module.exports = __webpack_public_path__ + "img/20.ad629602.png";